<template>
  <nav id="homepage_navbar" class="navbar flex items-center justify-between w-full">
    <router-link to="/" class="flex justify-center py-4 pl-3 pr-4">
      <ThemeImage
        id="superagi_logo"
        class="w-10 h-7 cursor-pointer"
        :icon="imageNames.SUPER_AGI_LOGO"
        alt="SuperAGI - AI Super App for Work"
      />
    </router-link>

    <div class="flex flex-row items-center">
      <a-button
          class="primary_medium mr-2 nav_button px-5"
          @click="navigateToSignUp"
      >
        <ThemeImage
            :icon="imageNames.BOLT_ICON"
            alt="bolt"
            class="size-4"
        />&nbsp;Sign up for free
      </a-button>
    </div>
  </nav>

  <SignInModal
    :visible="showSignInModal"
    @update:visible="showSignInModal = $event"
    @close="showSignInModal = false"
  />
</template>

<script setup>
import { ref } from "vue";
import { imageNames } from "@/src/constants/imageConstants.js";
import ThemeImage from "@/src/components/ThemeImage.vue";
import SignInModal from "@/src/views/homepage/SignInModal.vue";

const showSignInModal = ref(false);

const navigateToSignUp = () => {
  showSignInModal.value = true;
};
</script>

<style scoped>
.navbar {
  color: white;
  height: 48px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.nav_button {
  border-radius: 30px !important;
}

.signup-link {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  height: 32px;
}
</style>
